import './SliderVertical.scss';

import { b2x } from '@b2x/react/src';
import { SwiperSlide } from 'swiper/react';

import { Icon, isIconName } from '../Icon';
import { Slider } from './Slider';

export interface SliderVerticalProps {
  itemList?: Array<{
    cta?: b2x.contentTypes.CtaContentSection;
  }>;
}
export const SliderVertical = ({ itemList }: SliderVerticalProps) => {
  return (
    <Slider
      autoHeight
      autoplay={itemList && itemList.length > 1 ? { delay: 3000 } : undefined}
      className="slider-vertical"
      slidesPerView={1}
      vertical
    >
      {itemList &&
        itemList.map((item, index) => (
          <SwiperSlide
            className="d-flex justify-content-center align-items-center extra-small text-uppercase"
            key={item.cta?.label}
          >
            {(slideData) =>
              item.cta ? (
                <b2x.DeprecatedCta className="text-reset text-decoration-none" cta={item.cta}>
                  {item.cta.icon && isIconName(item.cta.icon) && (
                    <Icon className="me-1" name={item.cta.icon} size={16} />
                  )}
                  <span className="swiper-no-swiping">{item.cta.label}</span>
                </b2x.DeprecatedCta>
              ) : (
                <></>
              )
            }
          </SwiperSlide>
        ))}
    </Slider>
  );
};
